import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import styled from 'styled-components'
import Amplitude from '../../utils/amplitudeHelper'

const CustomModal = styled(Modal)`
  color: #505c7c;
  .modal-content {
    padding: 16px;
    border-radius: 24px;
  }
  .modal-header {
    border: none;
    padding: 0 8px;
    justify-content: flex-end;
  }
  .modal-body {
    padding: 0 16px;
  }
  .btn {
    display: block;
    width: 100%;
    margin-left: auto;
    border: 2px solid #FFAD2C;
    border-radius: 28px;
    padding: 6px 16px;
    background: #F83636;
    outline: none !important;
  }
  
`

export default function BoothNamecardModal({ currentUser, booth, modal, hideModal }) {

  const submitNamecard = () => {
    Amplitude.clickSendResume(booth.title)
    window.open(`mailto:${booth.company_email}`, "_blank" )
  }

  return (
    <CustomModal
      show={modal}
      onHide={hideModal}
      aria-labelledby="drop-name-card"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <p>
          Welcome to <strong>{booth.title}</strong> Booth!
        </p>
        <p>
          Feel free to send us your resume by clicking the button below.
        </p>
        <Button onClick={submitNamecard} className="mt-2">
          {'Send Us Your Resume'}
        </Button>
      </Modal.Body>
    </CustomModal>
  )
}
